const de = {
  contact: {
    heroHeading: 'Kontakt aufnehmen',
    heroSub: 'Ob Sie kaufen, verkaufen oder investieren m\u00f6chten \u2014 unser Team ist bei jedem Schritt f\u00fcr Sie da.',
    expertsBadge: 'Unsere Experten',
    expertsHeading: 'Das Team hinter Victory Homes',
    officeLabel: 'B\u00fcro-Adresse',
    phoneLabel: 'Telefonnummern',
    phoneOffice: 'B\u00fcro',
    phoneWA: 'Anruf / WhatsApp',
    emailLabel: 'E-Mail senden',
    followLabel: 'Folgen Sie uns',
    formHeading: 'Senden Sie uns eine Nachricht',
    formSub: 'F\u00fcllen Sie das Formular aus \u2014 wir melden uns innerhalb von 24 Stunden.',
    fieldName: 'Ihr Name *',
    fieldEmail: 'E-Mail-Adresse *',
    fieldPhone: 'Telefonnummer',
    fieldSubject: 'Betreff',
    fieldMessage: 'Ihre Nachricht *',
    sendBtn: 'Nachricht senden',
    sentBtn: '\u2713 Nachricht gesendet!',
    thankYou: 'Vielen Dank! Wir melden uns innerhalb von 24 Stunden.',
  },
  mort: {
    heroBadge: 'Hypothekenservice',
    heroLine1: 'Hypothekl\u00f6sungen f\u00fcr die VAE',
    heroAccent: 'Individuell f\u00fcr Sie',
    heroSub: 'Berechnen Sie Ihre monatliche Rate, pr\u00fcfen Sie Ihre Berechtigung und entdecken Sie Hypothekenangebote von 15+ VAE-Banken \u2014 alles an einem Ort.',
    tabCalc: '\ud83d\udcca Hypothekenrechner',
    tabElig: '\u2705 Berechtigungspr\u00fcfung',
    loanParams: 'Kreditparameter',
    propertyValue: 'Immobilienwert',
    downPayment: 'Anzahlung',
    annualRate: 'J\u00e4hrlicher Zinssatz',
    loanTenure: 'Kreditlaufzeit',
    years: (n) => `${n} Jahre`,
    minDown: '20\u00a0% (min.)',
    maxUAE: '25 Jahre (max. VAE)',
    monthlyEMI: 'Monatliche Rate (EMI)',
    loanAmount: 'Kreditbetrag',
    totalInterest: 'Gesamtzinsen',
    totalPayable: 'Gesamtbetrag',
    principalVsInterest: 'Tilgung vs. Zinsen',
    principal: 'Tilgung',
    interest: 'Zinsen',
    compareRates: '\ud83c\udfe6 VAE-Bankzinsen vergleichen',
    amortSchedule: '\ud83d\udcc5 J\u00e4hrlicher Tilgungsplan',
    basedOnLoan: (amt, yrs) => `Basierend auf Ihrem Kredit von AED\u00a0${amt} \u00fcber ${yrs}\u00a0Jahre. Zinss\u00e4tze sind indikativ.`,
    bankCol: 'Bank',
    fixedRate3yr: 'Festzins (3\u00a0Jahre)',
    variableEIBOR: 'Variabel (EIBOR+)',
    monthlyEMIFixed: 'Monatliche Rate (Fest)',
    totalCost: 'Gesamtkosten',
    eibor3mNote: (rate) => `* EIBOR 3\u00a0M: ${rate}\u00a0% (Referenzsatz). Variable Zinss\u00e4tze werden regelm\u00e4\u00dfig angepasst.`,
    yearCol: 'Jahr',
    principalPaid: 'Getilgter Betrag',
    interestPaid: 'Gezahlte Zinsen',
    balanceRemaining: 'Restschuld',
    yearRow: (n) => `Jahr ${n}`,
    financialProfile: 'Ihr Finanzprofil',
    residencyStatus: 'Aufenthaltsstatus',
    residencyOpts: [
      { value: 'resident',    label: '\ud83c\udfe0 VAE-Einwohner',   desc: '80\u00a0% LTV \u00b7 max. 25\u00a0Jahre' },
      { value: 'national',    label: '\ud83c\udde6\ud83c\uddea VAE-B\u00fcrger',  desc: '85\u00a0% LTV \u00b7 max. 25\u00a0Jahre' },
      { value: 'nonresident', label: '\u2708\ufe0f Nicht-Einwohner',  desc: '50\u00a0% LTV \u00b7 max. 15\u00a0Jahre' },
    ],
    yourAge: 'Ihr Alter',
    ageUnit: 'Jahre',
    monthlySalary: 'Monatsgehalt (AED)',
    otherIncome: 'Sonstiges monatliches Einkommen',
    existingEMI: 'Laufende Kreditraten (AED/Monat)',
    creditCard: 'Kreditkartenlimit (AED)',
    ccNote: 'Banken rechnen 5\u00a0% des Limits als monatliche Belastung an',
    assumedRate: 'Angenommener Zinssatz',
    checkBtn: '\ud83d\udd0d Berechtigung pr\u00fcfen',
    fillDetails: 'Bitte Angaben ausf\u00fcllen',
    fillDesc: 'Auf Basis der DBR-Regeln der Zentralbank der VAE berechnen wir den maximalen Kreditbetrag.',
    errTitle: 'Berechtigung konnte nicht berechnet werden',
    errDesc: 'Ihre laufenden Verbindlichkeiten \u00fcberschreiten m\u00f6glicherweise die 50-%-DBR-Grenze. Bitte kontaktieren Sie unsere Berater.',
    maxLoan: 'Maximaler Kreditbetrag',
    maxProperty: 'Maximaler Immobilienwert',
    minDownPay: 'Mindestanzahlung',
    maxTenure: 'Maximale Laufzeit',
    maxEMI: 'Max. erlaubte Monatsrate',
    dbrTitle: 'DBR-Analyse der VAE-Zentralbank',
    grossIncome: 'Bruttomonatseinkommen',
    existingObligs: 'Laufende Verbindlichkeiten',
    dbrHeadroom: 'DBR-Reserve (50-%-Regel)',
    ltvApplied: 'Angewendeter LTV',
    dbrNote: 'Ergebnisse sind indikativ. Die tats\u00e4chliche Berechtigung h\u00e4ngt von der Bankpr\u00fcfung ab.',
    readyApply: 'Bereit zum Beantragen?',
    readyApplyDesc: 'Unsere Berater sichern Ihnen den besten Zinssatz bei 15+ Banken.',
    talkAdvisor: 'Mit einem Berater sprechen \u2192',
    servicesBadge: 'Unsere Leistungen',
    servicesHeading: 'Alles Wichtige unter einem Dach',
    servicesSub: 'Victory Homes arbeitet mit f\u00fchrenden VAE-Banken zusammen, um transparente und schnelle Hypothekenleistungen anzubieten.',
    services: [
      { icon: '\ud83c\udfe0', title: 'Wohnhypothek', desc: 'Finanzieren Sie Ihr Traumhaus in den VAE zu wettbewerbsf\u00e4higen Zinsen.' },
      { icon: '\u2708\ufe0f', title: 'Nicht-Einwohner-Hypothek', desc: 'Sie wohnen au\u00dferhalb der VAE und m\u00f6chten investieren? Wir organisieren Hypotheken bis 50\u00a0% LTV.' },
      { icon: '\ud83d\udd04', title: 'Umschuldung / Eigenkapital', desc: 'Zahlen Sie zu viel auf Ihre bestehende Hypothek? Wechseln Sie die Bank und sparen Sie Tausende.' },
      { icon: '\ud83c\udfd7\ufe0f', title: 'Grund & Bau', desc: 'Spezialisierte Produkte f\u00fcr Grundst\u00fccksk\u00e4ufe und Bauprojekte.' },
      { icon: '\ud83d\udccb', title: 'Kostenlose Berechtigungspr\u00fcfung', desc: 'Wir bewerten Ihr Profil und stellen einen Voranerkennungsbrief von 5+ Banken aus.' },
      { icon: '\ud83d\udc64', title: 'Pers\u00f6nlicher Hypothekenberater', desc: 'Jeder Kunde erh\u00e4lt einen dedizierten Berater von der Antragstellung bis zur Schl\u00fcsselbergabe.' },
    ],
    ctaHeading: 'Bereit f\u00fcr den n\u00e4chsten Schritt?',
    ctaSub: 'Unsere Hypothekenberater helfen Ihnen, das beste Angebot zu sichern. Kostenlose Beratung, keine Verpflichtung.',
    ctaBtn: 'Kostenlose Beratung buchen \u2192',
  },
  offplan: {
    heroBadge: '\u2726 Dubai Off-Plan Immobilien',
    heroLine1: 'Investieren Sie, bevor',
    heroAccent: 'die Stadt es tut.',
    heroSub: 'Exklusiver Vorab-Zugang zu Dubais gefragtesten Projekten. Sichern Sie sich Premiumeinheiten zu heutigen Preisen \u2014 bevor der Markt reagiert.',
    browseBtn: 'Projekte durchsuchen',
    advisorBtn: 'Berater kontaktieren',
    statGrowth: 'Durchschn. Kapitalwachstum',
    statVisa: 'Gold-Visa-Schwellenwert',
    statComm: 'Provision f\u00fcr K\u00e4ufer',
    whyBadge: 'Warum Off-Plan',
    whyHeading: 'Die Wahl des klugen Investors',
    why: [
      { icon: '\ud83d\udcb0', title: 'G\u00fcnstiger Einstiegspreis', desc: 'Kauf zu Vorverkaufspreisen \u2014 typischerweise 20\u201330\u00a0% unter dem Marktwert bei Fertigstellung.' },
      { icon: '\ud83d\udcc5', title: 'Flexible Zahlungspl\u00e4ne', desc: 'Bautr\u00e4ger bieten 40/60- oder 20/80-Pl\u00e4ne \u2014 verteilen Sie Ihre Investition \u00fcber die Bauzeit.' },
      { icon: '\ud83d\udcc8', title: 'Kapitalwertsteigerung', desc: 'Dubai Off-Plan liefert historisch 30\u201350\u00a0% Wachstum vom Launch bis zur \u00dcbergabe.' },
      { icon: '\ud83e\ude99', title: 'Gold-Visa-berechtigt', desc: 'Immobilien ab 2 Mio. AED berechtigen zur 10-j\u00e4hrigen UAE Gold-Visa.' },
    ],
    featuredBadge: 'Ausgew\u00e4hlte Projekte',
    featuredHeading: 'Handverlesene Off-Plan-Projekte',
    catalogueLink: 'Vollst\u00e4ndigen Katalog anfordern \u2192',
    showingOf: (shown, total) => `${shown} von ${total} Projekten`,
    noMatchTitle: 'Keine passenden Objekte gefunden',
    noMatchDesc: 'Bitte erweitern Sie Ihre Suche oder passen Sie die Filter an.',
    clearFilters: 'Alle Filter zur\u00fccksetzen',
    communitiesBadge: 'Stadtteile erkunden',
    communitiesHeading: 'Dubais beliebteste Lagen',
    seeListings: 'Alle Angebote anzeigen \u2192',
    locations: [
      { name: 'Downtown', desc: ['Im Herzen von Dubais ikonischstem Viertel verk\u00f6rpert Downtown das Wesen des verfeinerten Stadtlebens.', 'Ger\u00e4umige Lounges und Panoramaterrassen mit unverbautem Blick auf die ber\u00fchmtesten Wahrzeichen der Stadt.'] },
      { name: 'Palm Jumeirah', desc: ['Palm Jumeirah verbindet Erbe und moderne Eleganz zu einer der renommiertesten Wohnadressen Dubais.', 'Sorgf\u00e4ltig gestaltete Residenzen und ruhige Au\u00dfenbereiche f\u00fcr einen lebenswerten Lifestyle.'] },
      { name: 'Marina', desc: ['Dubai Marina verbindet die Energie der Stadt mit der Idylle eines Wasserfront-Ambientes.', 'Private Marinas, malerische Promenaden und Panoramaterrassen mit unverstelltem Meerblick.'] },
      { name: 'Dubai Hills', desc: ['Dubai Hills vereint Natur und st\u00e4dtische Eleganz harmonisch zu einem ruhigen Wohnumfeld.', 'Ein Lebensumfeld, das Gesundheit, Stil und Gemeinschaft miteinander verbindet.'] },
      { name: 'Arabian Ranches', desc: ['Elegante Villen, bauumbetonte Stra\u00dfen und offene Fl\u00e4chen schaffen eine Gemeinschaft, in der Privatsph\u00e4re und Ruhe h\u00f6chste Priorit\u00e4t haben.', 'Golfpl\u00e4tze, Gemeindeparks und familienorientiertes Leben.'] },
    ],
  },
  sell: {
    heroBadge: 'Objekt inserieren',
    heroHeadline: 'Partnerschaft mit',
    heroAccent: 'Victory Homes',
    heroSub: 'Inserieren Sie Ihr Objekt mit unserem Expertenteam zum Kauf oder zur Miete. Wir kümmern uns um alles — von der Bewertung bis zum Abschluss.',
    formBadge: 'Für Eigentümer',
    formHeading: 'Inserieren Sie Ihr Objekt bei uns',
    formSub: 'Füllen Sie das Formular aus und unser Team übernimmt alles — von der Bewertung bis zum Abschluss.',
    tabSell: '🏷️ Verkaufen',
    tabRent: '🔑 Vermieten',
    sectionContact: 'Kontaktdaten',
    sectionProperty: 'Objektdetails',
    sectionDocs: 'Rechtliche Unterlagen',
    sectionPhotos: 'Objektfotos',
    fullName: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    whatsapp: 'WhatsApp (optional)',
    propertyType: 'Objekttyp',
    selectType: '— Typ auswählen —',
    emirate: 'Emirat',
    selectEmirate: '— Emirat auswählen —',
    community: 'Wohnanlage / Gebiet',
    subCommunity: 'Teilanlage / Gebäude',
    bedrooms: 'Schlafzimmer',
    bathrooms: 'Badezimmer',
    select: '— Auswählen —',
    areaSqFt: 'Fläche (Quadratfuß)',
    floor: 'Stockwerk',
    furnishing: 'Einrichtung',
    completion: 'Fertigstellungsstatus',
    ready: 'Fertig',
    offPlan: 'Projektimmobilie',
    askingPrice: 'Angebotspreis',
    rentAmount: 'Mietpreis (jährlich)',
    priceHint: 'Betrag ohne Kommas eingeben. Der Preis sollte den aktuellen Marktwert widerspiegeln.',
    youtubeLink: 'YouTube-Videolink',
    youtubeHint: 'Fügen Sie einen YouTube-Link hinzu, um Ihre Immobilie zu präsentieren (optional)',
    description: 'Objektbeschreibung',
    descPlaceholder: 'Beschreiben Sie Ihr Objekt — Ausstattung, Aussichten, Modernisierungen, nahegelegene Einrichtungen…',
    docsIntro: 'Diese Unterlagen bestätigen das Eigentum und erleichtern die Listung. Alle Dateien werden sicher aufbewahrt.',
    titleDeed: 'Eigentumsurkunde',
    titleDeedHint: 'Offizielle Eigentumsurkunde.',
    floorPlan: 'Grundriss',
    floorPlanHint: 'Architektonischer Grundriss.',
    passport: 'Reisepasskopie',
    passportHint: 'Gültiger Reisepass des Eigentümers.',
    privacy: 'Datenschutz gewährleistet. Ihre Unterlagen sind verschlüsselt und nur für unser autorisiertes Team zugänglich.',
    photosLabel: 'Objektfotos',
    photosHint: 'Bis zu 20 Bilder — JPG, PNG, WEBP. Das erste Bild wird das Titelbild.',
    photosIntro: 'Gute Fotos erhöhen die Anfragen erheblich. Helle Weitwinkelaufnahmen jedes Zimmers verwenden.',
    dragDrop: 'Ziehen & ablegen oder',
    browse: 'durchsuchen',
    accepted: 'PDF, JPG, PNG akzeptiert',
    clickReplace: 'Klicken zum Ersetzen',
    dropPhotos: 'Fotos hier ablegen',
    orClickBrowse: 'oder zum Durchsuchen klicken',
    upTo20: 'Bis zu 20 Bilder',
    photosAdded: (n) => `${n} Foto${n !== 1 ? 's' : ''} hinzugefügt`,
    submitSale: '🚀 Verkaufsanzeige einreichen',
    submitRental: '🚀 Mietanzeige einreichen',
    submitting: '⏳ Wird gesendet…',
    termsNotice: 'Mit dem Absenden stimmen Sie den Nutzungsbedingungen von Victory Homes zu.',
    successTitle: 'Anzeige eingereicht!',
    successDesc: 'Unser Team wird prüfen und sich innerhalb von',
    successHours: '24 Stunden',
    submitAnother: 'Weitere einreichen',
    errName: 'Vollständiger Name ist erforderlich',
    errEmail: 'Gültige E-Mail ist erforderlich',
    errPhone: 'Telefonnummer ist erforderlich',
    errPropType: 'Objekttyp auswählen',
    errEmirate: 'Emirat auswählen',
    errPrice: 'Angebotspreis ist erforderlich',
    errRent: 'Mietpreis ist erforderlich',
    errPhotos: 'Mindestens ein Foto ist erforderlich',
  },
  props: {
    heroBadge: 'Immobilien in den VAE',
    listingCount: (n) => `${n} Inserat${n !== 1 ? 'e' : ''} verfügbar`,
    tabBuy: 'Kaufen',
    tabRent: 'Mieten',
    portfolio: 'Unser Portfolio',
    forSale: 'Immobilien zum Kauf',
    forRent: 'Immobilien zur Miete',
    listYourProperty: 'Objekt inserieren →',
    buy: {
      badge: 'Immobilien zum Kauf',
      headline: 'Finden Sie Ihre',
      accent: 'ideale Kaufimmobilie',
      sub: 'Entdecken Sie geprüfte Verkaufsangebote, handverlesen von unserem Expertenteam in den VAE.',
    },
    rent: {
      badge: 'Immobilien zur Miete',
      headline: 'Finden Sie Ihre',
      accent: 'ideale Mietimmobilie',
      sub: 'Stöbern Sie in hochwertigen Mietangeboten in Dubai und den Emiraten, kuratiert von Victory Homes.',
    },
    enquireNow: 'Jetzt anfragen →',
    noMatchTitle: 'Keine Inserate entsprechen Ihren Filtern',
    noMatchDesc: 'Versuchen Sie, Budget, Typ oder Gebiet anzupassen.',
    clearFilters: 'Alle Filter zurücksetzen',
    emptyBuy: 'Derzeit keine Kaufobjekte gelistet',
    emptyRent: 'Derzeit keine Mietobjekte gelistet',
    emptyDesc: () => 'Unser Portfolio wird regelmäßig aktualisiert — schauen Sie bald wieder vorbei oder kontaktieren Sie uns direkt.',
    speakAgent: 'Mit einem Makler sprechen →',
    listProp: 'Objekt inserieren',
    exploreOther: 'Weitere Objekte entdecken',
    otherForSale: 'Weitere zum Kauf verfügbare Objekte',
    otherForRent: 'Weitere zur Miete verfügbare Objekte',
    otherDesc: 'Während wir diese Kategorie befassen, finden Sie hier weitere Objekte aus unserem Portfolio.',
    ctaBadge: 'Bereit zum Inserieren?',
    ctaHeading: 'Haben Sie ein Objekt zu inserieren?',
    ctaDesc: 'Unsere Experten kümmern sich um alles — von der Bewertung bis zum Abschluss. Inserieren Sie heute mit Victory Homes.',
    contactUs: 'Kontakt aufnehmen',
  },
  featured: {
    tag: 'Exklusive Immobilien',
    heading: 'Entdecken Sie exklusive Immobilien mit Emirates',
    desc: 'Finden Sie die beste Auswahl luxuriöser Häuser und erstklassiger Immobilienchancen mit Emirates. Treten Sie in den Lebensstil ein, den Sie verdienen.',
  },
  partners: {
    tag: 'Unsere Partner',
    heading: 'Objekte von führenden Entwicklern der VAE',
    learnMore: 'Mehr erfahren',
    learnMoreArrow: 'Mehr erfahren →',
    oasis: { title: 'Oasis Garden Villas', desc: 'Großzügige moderne Häuser mit privaten Gärten, schattigen Innenhöfen und naturinspirierten Grundrissen — für Ruhe, Eleganz und Familienleben.' },
    ghaf:  { title: 'Ghaf Woods, Dubai', desc: 'Ein locker bebautes Wohnviertel mit umweltbewussten Häusern, fußgängerfreundlichen Räumen und üppigem Grün — für Wohlbefinden und nachhaltiges Wohnen.' },
    nad:   { title: 'Nad Al Sheba', desc: 'Ein exklusives Wohnviertel mit geräumigen Villen in ruhiger Lage, bekannt für Privatsphäre, Grünanlagen und Nähe zu Dubais wichtigsten Sehenswürdigkeiten.' },
    district: { title: 'District One, Dubai', desc: 'Ultraluxuriöse, durchgeplante Gemeinschaft mit eleganten Villen und Anwesen an Kristallseen und üppigem Grün — geschaffen für Privatsphäre und Prestige.' },
  },
  media: {
    tag: 'Medienberichte',
    heading: 'In den Schlagzeilen der Presse',
    readArticle: 'Artikel lesen',
  },
  newsletter: {
    badge: 'Bleiben Sie informiert',
    heading: 'Behalten Sie den Überblick auf dem Immobilienmarkt Dubai',
    desc: 'Exklusive Angebote, Markteinblicke und Investitionschancen direkt in Ihr Postfach — bevor sie auf den Markt kommen.',
    placeholder: 'E-Mail-Adresse eingeben',
    btn: 'Abonnieren →',
    privacy: '🔒 Kein Spam. Abmeldung jederzeit. Ihre Daten sind sicher.',
    success: '✓ Sie sind abonniert! Willkommen in der Victory Homes Community.',
    error: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  },
  nav: {
    home: 'Startseite', properties: 'Immobilien', buy: '🏡 Kaufen', rent: '🔑 Mieten',
    sellRent: 'Verkaufen/Vermieten', offplan: 'Projektimmobilien', services: 'Dienstleistungen',
    holidayHomes: 'Ferienhäuser', propertyManagement: 'Immobilienverwaltung',
    fitOut: 'Ausbau & Renovierung, Umzug & Verpackung',
    legalAssistance: 'Rechtsbeistand',
    valuation: 'Immobilienbewertung',
    calculators: 'Hypothek',
    transactions: 'Transaktionen',
    mortgage: 'Hypothekenrechner', contact: 'Kontakt', roiCalc: 'ROI-Rechner',
    areaIntelligence: 'Stadtteil-Analyse',
  },
  valuation: {
    heroTitle: 'Kostenlose Immobilienbewertung',
    heroDesc: 'Denken Sie an einen Verkauf? Erhalten Sie eine sofortige, datengestützte Bewertung des aktuellen Marktwerts.',
    successTitle: 'Anfrage erhalten!',
    successDesc: 'Unsere Bewertungsexperten werden Ihre Daten prüfen und sich in Kürze mit Ihnen in Verbindung setzen.',
    submitAnother: 'Weitere Anfrage senden',
    fullName: 'Vollständiger Name *',
    phone: 'Telefonnummer *',
    email: 'E-Mail-Adresse',
    propType: 'Immobilientyp *',
    selectType: 'Typ auswählen',
    location: 'Standort / Gemeinde *',
    locPlaceholder: 'z.B. Dubai Marina',
    bedrooms: 'Schlafzimmer',
    select: 'Auswählen',
    area: 'Bebaute Fläche (Sq.Ft)',
    areaPlaceholder: 'z.B. 1500',
    submit: 'Kostenlose Bewertung anfordern',
    submitting: 'Senden...',
    fail: 'Senden fehlgeschlagen. Bitte erneut versuchen.'
  },
  recentlySold: {
    title: 'Kürzlich verkaufte Immobilien',
    desc: 'Eine Auswahl unserer neuesten erfolgreichen Transaktionen. Erleben Sie den Unterschied von Victory Homes.',
    badge: 'Verkauft',
    beds: 'Betten'
  },
  trust: {
    clientStories: 'Kundengeschichten',
    hearFromClients: 'Das sagen unsere Kunden',
    videoUnavailable: 'Video nicht verfügbar',
    trackRecord: 'Erfolgsbilanz',
    provenSuccess: 'Nachgewiesener Erfolg'
  },
  areaIntelligence: {
    heroBadge: 'Dubai Stadtteil-Intelligenz',
    heroLine1: 'Datenbasierte Einblicke für',
    heroAccent: 'Jeden Dubai-Stadtteil.',
    heroSub: 'Erkunden Sie Preistrends, Mietrenditen und KI-gestützte Investitionsanalysen für die begehrtesten Gemeinschaften Dubais.',
    modeBuy: 'Kaufen',
    modeRent: 'Mieten',
    modeOffplan: 'Projektobjekt',
    filterTitle: 'Filter & Metriken',
    heatmapLabel: 'Kartenmetrik',
    chartAreasLabel: 'Diagramm-Gebiete',
    selectAll: 'Alle',
    selectNone: 'Keine',
    loading: 'Gebietsdaten werden geladen…',
    mapsKeyMissing: 'Google Maps API-Schlüssel erforderlich',
    mapsKeyHint: 'VITE_GOOGLE_MAPS_API_KEY in Ihre .env-Datei einfügen und neu laden.',
    mapFailedLoad: 'Karte konnte nicht geladen werden. API-Schlüssel prüfen.',
    mapLoading: 'Karte wird geladen…',
    legendSelectedArea: '⬤ Ausgewähltes Gebiet',
    legendSelectedDesc: 'Weiße Blase = Ihre aktive Auswahl',
    legendLow: { avgPrice: 'Niedrigerer Preis', rentalYield: 'Niedrigere Rendite', demandScore: 'Geringe Nachfrage', avgPricePerSqft: 'Niedrigerer Preis/qf' },
    legendHigh: { avgPrice: 'Höherer Preis', rentalYield: 'Höhere Rendite', demandScore: 'Hohe Nachfrage', avgPricePerSqft: 'Höherer Preis/qf' },
    activeProjects: 'Aktive Projekte',
    nearbyLandmarks: '📍 Sehenswürdigkeiten in der Nähe',
    kpiAvgPrice: 'Ø Preis',
    kpiPricePerSqft: 'Preis / qf',
    kpiGrossYield: 'Bruttorendite',
    kpiDemandScore: 'Nachfrage-Index',
    aiInsightTitle: '✦ KI-Marktanalyse',
    aiGenerate: 'Generieren →',
    aiAnalysing: 'Marktdaten werden analysiert…',
    aiKeyMissing: 'GEMINI_API_KEY in backend/.env hinzufügen, um KI-Analysen zu aktivieren.',
    aiPrompt: 'Klicken Sie auf „Generieren" für eine KI-gestützte Investitionsanalyse für dieses Gebiet.',
    browseOffplan: (name) => `Projektobjekte in ${name} entdecken →`,
    viewResale: 'Wiederverkaufsobjekte anzeigen →',
    priceTrendBadge: 'Preistrend',
    priceTrendTitle: '12-Monats-Preis pro qf (AED)',
    priceTrendSub: '12-Monats-Trend auf Basis aggregierter Marktdaten',
    rentalYieldBadge: 'Mietrendite',
    rentalYieldTitle: 'Brutto-Mietrendite nach Gebiet (%)',
    rentalYieldSub: 'Basierend auf Ø-Jahresmiete vs. Ø-Kaufpreis',
    tooltipYield: (val, name) => [`${val}% Bruttorendite`, name],
    comparisonBadge: 'Gebietsvergleich',
    comparisonTitle: 'Bis zu 3 Gebiete vergleichen',
    comparisonSub: 'Gebiete unten auswählen, um sie nebeneinander zu vergleichen',
    comparisonPlaceholder: 'Wählen Sie Gebiete oben aus, um den Vergleich zu sehen',
    colMetric: 'Metrik',
    rowAvgPrice: 'Ø Preis',
    rowPricePerSqft: 'Preis / qf',
    rowGrossYield: 'Bruttorendite',
    rowDemandScore: 'Nachfrage-Index',
    rowActiveProjects: 'Aktive Projekte',
    rowMinEntry: 'Min. Einstiegspreis',
    rowMaxPrice: 'Max. Preis',
    best: 'Bester',
    metricAvgPrice: 'Ø Preis',
    metricRentalYield: 'Mietrendite',
    metricDemand: 'Nachfrage',
    metricPricePerSqft: 'Preis/qf',
  },
  hero: {
    slide1H: 'Wo intelligente Daten, maßgeschneidene Beratung und menschliches Vertrauen zusammentreffen.',
    slide1P: 'Victory Homes ist Dubais erster Makler, der Menschen hilft, das Leben zu entdecken, das sie sich wünschen, bevor sie das richtige Zuhause finden.',
    slide1Btn: 'Entdecken',
    slide2H: 'Exklusive Wasserlagen.',
    slide2P: 'Erleben Sie unvergleichlichen Luxus auf der berühmtesten Künstlichen Insel der Welt — Palm Jumeirah.',
    slide2Btn: 'Palm erkunden',
    slide3H: 'Zukunftsleben, perfekt abgestimmt.',
    slide3P: 'Mithilfe von Umweltdaten und prädiktiver Modellierung verbinden wir Menschen mit visionären Gemeinschaften in Dubai Marina.',
    slide3Btn: 'Marina entdecken',
    slide4H: 'Finden Sie das Leben, nicht nur das Haus.',
    slide4P: 'Entdecken Sie ein privates Refugium umgeben von der legendären Crystal Lagoon und weitläufigen Grünanlagen in District One.',
    slide4Btn: 'District One ansehen',
  },
  stats: {
    impact: 'Unser Geschäftserfolg',
    sold: 'Gesamt verkauft 2020–2024',
    lifetime: 'Gesamtes Verkaufsvolumen',
    current: 'Aktuelles Angebotsvolumen',
  },
  sellTestimonials: {
    tag: 'Referenzen',
    heading: 'Mit Victory Homes verkaufen — schnell und effizient',
    desc: 'Ein reibungsloser, transparenter Prozess zur Maximierung Ihres Immobilienwerts bei minimalem Stress.',
  },
  team: {
    tag: 'Das Team',
    heading: 'Lernen Sie die führenden Immobilienexperten der Emirate kennen',
    desc: 'Unsere engagierten Makler bei Victory Homes sind erfahrene Profis, die Sie durch jeden Schritt begleiten.',
    btn: 'Das gesamte Team kennenlernen →',
  },
  goldenVisa: {
    badge: '🇦🇪 Investorenvorteile',
    heading: 'VAE Golden Visa',
    headingGold: 'Durch Immobilien',
    desc: 'Investieren Sie in VAE-Immobilien im Wert von <strong>2.000.000 AED oder mehr</strong> und erhalten Sie ein <strong>10-jähriges erneuerbares VAE-Aufenthaltsvisum</strong> — für Sie und Ihre Familie.',
    cta: 'Berechtigung prüfen →',
    benefitsHeading: 'Warum das Golden Visa ein Gamechanger ist',
    benefitsSubheading: 'Das VAE Golden Visa öffnet Türen, die die meisten Länder schlicht nicht bieten.',
    stepsHeading: 'So erhalten Sie Ihr Golden Visa',
    stepsSubheading: '4 klare Schritte — unser Team begleitet Sie bei jedem',
    stepCtaHeading: 'Bereit, Ihr VAE Golden Visa zu sichern?',
    stepCtaDesc: 'Unsere Berater finden die richtige qualifizierende Immobilie für Ihr Budget und Ihre Ziele.',
    stepCtaBtn: 'Berater kontaktieren',
    yearVisa: 'Jahre Visum',
    minValue: 'Mindestimmobilienwert',
    benefits: {
      b1t: '10-jährige Aufenthaltserlaubnis', b1d: 'Sichern Sie sich ein jahrzehntelanges VAE Golden Visa durch Investitionen ab 2 Mio. AED.',
      b2t: 'Familienzusammenführung', b2d: 'Ehepartner, Kinder und Eltern unter demselben Visum sponsern — ohne separate Anträge.',
      b3t: 'Kein Sponsor erforderlich', b3d: 'Leben, arbeiten und studieren in den VAE ohne Arbeitgeber oder lokalen Sponsor.',
      b4t: 'Unbegrenzt verlängerbar', b4d: 'Solange Sie die qualifizierende Immobilie besitzen, wird das Golden Visa automatisch verlängert.',
      b5t: 'Globale Mobilität', b5d: 'Mehrfacheinreiseprivilegien und längere Auslandsaufenthalte ohne Visumsverlust.',
      b6t: 'Investitionssicherheit', b6d: 'VAE-Immobilien sind erstklassige Anlageklasse — verbinden Sie Residenz mit starkem Wertzuwachs.',
    },
    steps: {
      s1: 'Immobilie im Wert von mindestens 2 Mio. AED erwerben',
      s2: 'Eigentumsurkunde vom Dubai Land Department erhalten',
      s3: 'Mit Unterstützung unseres Teams über ICA oder GDRFA beantragen',
      s4: '10-jähriges Golden Visa und Emirates ID erhalten',
    },
  },
  blog: {
    tag: 'Der Blog',
    heading: 'Einblicke und Nachrichten vom Immobilienblog der Emirate',
    desc: 'Die neuesten Marktnachrichten, Tipps und Experteneinblicke zum Immobilienmarkt Dubai.',
    readMore: 'Weiterlesen',
  },
  evo: {
    statsBadge: 'Dubai in Zahlen',
    statsHeading: 'Die Entwicklung des Immobilienmarkts Dubai',
    statsDesc: 'Von einem regionalen Handelshafen zum dynamischsten Immobilienmarkt der Welt in nur zwei Jahrzehnten.',
    timelineBadge: 'Die Geschichte',
    timelineHeading: 'Wie Dubai zum No. 1 Immobilienziel der Welt wurde',
    timelineCTA: 'Möchten Sie verstehen, wohin sich der Dubai-Markt entwickelt?',
    timelineBtn: 'Mit Marktexperten sprechen →',
    stats: {
      s1l: 'Immobilientransaktionen 2024', s2l: 'AED Gesamtverkaufswert 2024',
      s3l: 'Immobilienpreiswachstum seit 2020', s4l: 'Nationalitäten in Dubai',
    },
    timeline: {
      t1t: 'Freihalte-Gesetz', t1d: 'Dubai erlaubt Ausländern Eigentum in speziellen Freihaltezonen — erste Investitionswelle.',
      t2t: 'Skyline-Transformation', t2d: 'Der Burj Khalifa öffnet. Dubai wird zur weltweit bekanntesten modernen Stadt.',
      t3t: 'Golden Visa eingeführt', t3d: 'Die VAE starten das 10-jährige Golden Visa-Programm — starker Nachfrageanstieg bei 2 Mio. AED+ Objekten.',
      t4t: 'Rekordmarkt', t4d: 'Post-Pandemie-Erholung treibt einen historischen Preisanstieg von über 60% an.',
      t5t: 'Neue Allzeithochs', t5d: 'Dubai verbucht 96.000+ Transaktionen im Wert von 411 Mrd. AED.',
      t6t: 'Dubai 2040 Stadtplan', t6d: 'Ziel: Grünflächen verdoppeln, 5 Stadtzentren und 5,8 Mio. Einwohner bis 2040.',
    },
  },
  txn: {
    badge: 'Unterstützt von DXBinteract',
    heading: 'Dubai Transaktionsberichte',
    desc: 'Zugriff auf Live-Daten des Dubai Land Departments — jeder Verkauf erfasst, jeder Preis verfolgt.',
    live: 'Live DLD-Daten',
    openPlatform: 'Vollständige Plattform öffnen ↗',
    viewReport: 'Bericht ansehen →',
    ctaHeading: 'Möchten Sie einen personalisierten Bericht für eine bestimmte Zone?',
    ctaDesc: 'Unsere Berater können gebietsbezogene Daten abrufen und für Ihre Investition interpretieren.',
    ctaBtn: 'Berater fragen',
    reports: {
      r1l: 'Tagesbericht', r1d: 'Jede DLD-Transaktion — täglich aktualisiert.',
      r2l: 'Wochenbericht', r2d: 'Wöchentliche Übersicht: Verkaufsvolumen, Preise und Gebietstendenzen.',
      r3l: 'Monatsbericht', r3d: 'Tiefenanalyse der Monatsleistung über alle Immobilientypen.',
      r4l: 'Quartalsbericht', r4d: 'Quartalsvergleich: Preisveränderungen, Top-Gebiete, Investorenaktivität.',
      r5l: 'Jahresbericht', r5d: 'Jahresmarktüberblick: Rekorddeals, aufstrebende Gemeinschaften, Prognose.',
      r6l: 'Gebietspreiskarte', r6d: 'Interaktive Heatmap mit Preis pro Quadratfuß für alle Dubai-Gemeinschaften.',
    },
  },
  cta: {
    buying: 'Kaufen beginnen', selling: 'Verkaufen beginnen', contact: 'Kontaktieren',
    findOut: 'Mehr erfahren', comingSoon: 'Demnächst',
  },
  offplanPromo: {
    badge: 'Projektimmobilien',
    heading: 'Neue Projekte & exklusive Vorverkaufsangebote',
    desc: 'Sichern Sie sich Einheiten in Dubais gefragtesten Projekten — bevor sie ausverkauft sind. Golden Visa-fähig ab 2 Mio. AED.',
    btn: 'Projektimmobilien entdecken →',
  },
  topCommunities: {
    badge: 'Markteinblicke',
    heading: 'Dubais Top-Gemeinden',
    desc: 'Strategische Einblicke für Investoren und Eigennutzer (2026-2027)',
    tabs: {
      roi: 'ROI-Spitzenreiter',
      villas: 'Villen & Reihenhäuser',
      budget: 'Nach Budget',
      strategy: 'Strategie-Leitfaden'
    },
    roi: {
      title: 'Top-Gemeinden für ROI (2026–2027)',
      desc: 'Diese Gebiete liefern konstant starke Mietrenditen und Wertsteigerungen.',
      list: [
        'Jumeirah Village Circle',
        'Dubai South',
        'Arjan',
        'Dubai Silicon Oasis',
        'Dubai Sports City',
        'Business Bay',
        'Dubai Marina'
      ],
      insightTitle: 'Wichtige Erkenntnis',
      insights: [
        'JVC + Arjan = höchste Renditen (6–9%)',
        'Marina + Business Bay = geringere Rendite, aber stärkere Wertsteigerung + Liquidität'
      ]
    },
    villas: {
      title: 'Beste Gemeinden für Villen / Reihenhäuser',
      desc: 'Fokus auf Eigennutzer, Familien und langfristiges Wohnen.',
      list: [
        'Dubai Hills Estate',
        'Arabian Ranches',
        'Tilal Al Ghaf',
        'DAMAC Hills',
        'The Valley',
        'Mudon',
        'Town Square'
      ],
      insightTitle: 'Wichtige Erkenntnis',
      insights: [
        'Dubai Hills = beste Balance (Lage + Qualität)',
        'Tilal Al Ghaf = Premium-Lifestyle-Gemeinde',
        'Town Square / Valley = Einstiegsvillen'
      ]
    },
    budget: {
      title: 'Beste Gemeinden nach Budget',
      categories: [
        {
          name: 'Einstiegslevel',
          range: 'AED 500K – 900K',
          areas: ['International City', 'Dubai South', 'Discovery Gardens', 'Dubai Production City', 'Liwan'],
          bestFor: 'Erstinvestoren, höchste Mietrendite'
        },
        {
          name: 'Mittelklasse',
          range: 'AED 900K – 2M',
          areas: ['Jumeirah Village Circle', 'Arjan', 'Al Furjan', 'Dubai Silicon Oasis', 'Dubai Creek Harbour'],
          bestFor: 'Balance zwischen ROI + Wertsteigerung'
        },
        {
          name: 'Gehobene Mittelklasse / Premium',
          range: 'AED 2M – 5M',
          areas: ['Business Bay', 'Dubai Marina', 'Dubai Hills Estate', 'Palm Jumeirah (Einstiegs-Einheiten)'],
          bestFor: 'Liquidität + starke Wiederverkaufsnachfrage'
        },
        {
          name: 'Luxus',
          range: 'AED 5M+',
          areas: ['Downtown Dubai', 'Palm Jumeirah', 'Emirates Hills', 'District One', 'Jumeirah Bay Island'],
          bestFor: 'Kapitalerhalt + Prestigeobjekte'
        }
      ]
    },
    strategy: {
      title: 'Einfacher Strategie-Leitfaden',
      guide: [
        { goal: 'maximaler ROI', action: 'JVC, Arjan, Dubai South' },
        { goal: 'sichere Investition', action: 'Dubai Hills, Marina' },
        { goal: 'Luxus-Wertsteigerung', action: 'Palm Jumeirah, Downtown' },
        { goal: 'Familienwohnen', action: 'Arabian Ranches, Tilal Al Ghaf' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "Victory Dienstleistungen",
    "whyChoose": "Warum unser {service}?",
    "form": {
        "fullName": "Vollständiger Name",
        "email": "E-Mail Adresse",
        "phone": "Telefonnummer",
        "detailsOpt": "Immobiliendetails (Optional)",
        "messageOpt": "Zusätzliche Nachricht oder Anforderungen",
        "submitRequest": "Anfrage absenden",
        "submitting": "Wird gesendet...",
        "successTitle": "Anfrage erhalten!",
        "successDesc": "Vielen Dank für Ihre Anfrage zu {service}. Unser Team wird diese prüfen und sich in Kürze bei Ihnen melden.",
        "submitAnother": "Weitere Anfrage senden",
        "errors": {
            "nameReq": "Bitte geben Sie Ihren vollständigen Namen ein",
            "emailReq": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            "phoneReq": "Bitte geben Sie Ihre Telefonnummer ein",
            "failSub": "Fehler beim Senden. Bitte versuchen Sie es später noch einmal."
        },
        "placeholders": {
            "name": "z.B. Max Mustermann",
            "email": "sie@beispiel.com",
            "phone": "+971 50 123 4567",
            "details": "z.B. 2-Zimmer-Wohnung in Downtown Dubai",
            "message": "Wie können wir Ihnen helfen?"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "Ferienhäuser",
            "heroSub": "Maximieren Sie Ihre Rendite mit unserem erstklassigen Kurzzeitmiet-Management.",
            "desc": "Verwandeln Sie Ihre Immobilie ohne Aufwand in ein lukratives Ferienhaus. Wir übernehmen Marketing, Gästebetreuung und Wartung. Der Tourismusmarkt in Dubai bietet exzellente ROIs.",
            "extraDesc": "Von der Einrichtung über professionelle Fotografie bis hin zu optimierten Inseraten – wir sorgen für maximale Auslastung plus 24/7 Gästesupport.",
            "points": [
                "Dynamische Preisgestaltung & Marketing",
                "24/7 Gästebetreuung",
                "Professionelle Reinigung",
                "Monatliches ROI-Reporting",
                "Unterstützung bei rechtlichen Fragen"
            ],
            "formTitle": "Ferienhaus-Management anfragen",
            "formDesc": "Teilen Sie uns mit, wie wir Ihnen helfen können."
        },
        "property-management": {
            "title": "Immobilienverwaltung",
            "heroSub": "Umfassendes Management für sorgenfreies und stabiles Einkommen.",
            "desc": "Vom Mieterscreening bis zu Wartungsanfragen verwaltet unser Team Ihre Investitionen sicher und professionell.",
            "extraDesc": "Wir nehmen Ihnen den Stress. Von der Ejari-Registrierung über Mieteinzug bis zu Inspektionen und Notfallreparaturen.",
            "points": [
                "Umfassende Mieterprüfung",
                "Mieteinzug & Finanzberichte",
                "Ejari & rechtliche Compliance",
                "Routinemäßige Inspektionen & Wartung",
                "Streitbeilegung"
            ],
            "formTitle": "Immobilienverwaltung anfragen",
            "formDesc": "Geben Sie Ihre Daten ein für einen maßgeschneiderten Plan."
        },
        "fit-out": {
            "title": "Innenausbau & Renovierung",
            "heroSub": "Verwandeln Sie Ihre Räume mit unserem Weltklasse-Innendesign.",
            "desc": "Maßgeschneidertes Design und Umsetzung für Wohn- und Geschäftsräume, von Luxusvillen bis zu modernen Büros.",
            "extraDesc": "Unsere Designer arbeiten eng mit Ihnen zusammen und garantieren Präzision, Genehmigungen und erstklassige Materialien.",
            "points": [
                "Maßgeschneiderte Designkonzepte",
                "Raumplanung & 3D-Visualisierung",
                "Komplette Projektabwicklung",
                "Behördliche Genehmigungen",
                "Möbel & Materialbeschaffung"
            ],
            "formTitle": "Beratung zum Innenausbau",
            "formDesc": "Vereinbaren Sie eine Beratung für Ihre Immobilie."
        },
        "legal-assistance": {
          title: "Rechtsbeistand",
          heroSub: "Kompetente rechtliche Beratung für sichere Immobilientransaktionen in den VAE.",
          desc: "Das Navigieren durch Dubais Immobilienrecht erfordert Präzision. Wir bieten vollständige rechtliche Unterstützung für sichere und stressfreie Transaktionen.",
          extraDesc: "Von der gründlichen Titelprüfung bis hin zur Sicherstellung der vollständigen RERA-Konformität schützen unsere Experten Ihre Interessen.",
          points: ["Titelprüfung & Due Diligence", "RERA-Konformität", "Vorbereitung der Kaufurkunde", "Überprüfung des Immobilienkaufs", "Streitbeilegung"],
          formTitle: "Rechtsbeistand anfordern",
          formDesc: "Geben Sie Ihre Daten an und unsere Rechtsexperten werden sich mit Ihnen in Verbindung setzen."
        }
    }
},
  footer: {
    letsWork: 'Zusammenarbeiten',
    email: 'E-Mail',
    callWhatsApp: 'Anruf / WhatsApp',
    ourLocation: 'Unser Standort',
    officePhone: 'Bürotelefon',
    tagline: 'Ihr vertrauenswürdiger Immobilienpartner in Dubai. Spezialisiert auf Kauf, Verkauf und Vermietung von Premiumimmobilien in den VAE.',
    ourServices: 'Unsere Dienstleistungen',
    usefulLinks: 'Nützliche Links',
    copyright: '© 2025 Victory Homes. Alle Rechte vorbehalten.',
    serviceLinks: ['Neue Immobilien', 'Ihr Objekt verkaufen', 'Unsere Dienstleistungen', 'Pressemitteilung'],
    headline: 'Unser Team qualifizierter Immobilienmakler steht Ihnen jederzeit und überall zur Verfügung.',
  },
  offplanDetail: {
    overview: "Überblick",
    propertyTypes: "Immobilientypen",
    totalUnits: "Gesamteinheiten",
    handover: "Übergabe",
    startingPrice: "Startpreis",
    startingFrom: "Ab",
    paymentPlan: "Zahlungsplan",
    location: "Lage & Anbindung",
    mins: "Min.",
    unitType: "Einheitstyp",
    size: "Größe",
    availableOptions: "Verfügbare Optionen",
    getBrochure: "Broschüre anfordern",
    reqDetails: "Details anfordern",
    dlBrochure: "Broschüre herunterladen",
    dlFloorPlans: "Grundrisse herunterladen",
    fullName: "Vollständiger Name *",
    emailAdd: "E-Mail Adresse *",
    phoneNum: "Telefonnummer",
    reqDesc: "Füllen Sie Ihre Daten aus, um das komplette Projekt-{type} für {name} zu erhalten.",
    reqSuccess: "Anfrage erhalten",
    reqSuccessDesc: "Danke. Einer unserer Spezialisten wird Ihnen in Kürze die Broschüre und Grundrisse per E-Mail zusenden.",
    close: "Schließen",
    submitting: "Wird gesendet...",
    reqType: "{type} anfordern",
    types: {
        Apartment: "Wohnung",
        Townhouse: "Stadthaus",
        Villa: "Villa",
        Penthouse: "Penthouse",
        Mansion: "Herrenhaus",
        Duplex: "Duplex",
        Plot: "Grundstück"
    },
    tags: {
        waterfront: "Am Wasser",
        family: "Familie",
        luxury: "Luxus",
        investment: "Investition",
        golf: "Golfplatz",
        urban: "Urban",
        nature: "Natur"
    },
    beds: {
        studio: "Studio",
        br: "Schlafz.",
        units: "Einheiten",
        various: "Verschiedene"
    }
}
,
  offplanExtra: {
        "interested": "Interessiert?",
        "readyToSecure": "Bereit, Ihre Einheit zu sichern in",
        "advisorGuide": "Unsere spezialisierten Berater können Sie durch die Preise, Zahlungsoptionen und den gesamten Kaufprozess führen — ohne Provision.",
        "getInTouch": "Kontakt aufnehmen",
        "whatsapp": "WhatsApp",
        "enquire": "Anfragen",
        developer: "Bauträger",
    community: "Gemeinschaft",
    buildingHeight: "Gebäudehöhe",
    retailSpace: "Einzelhandelsfläche",
    furnishing: "Möblierung",
    about: "Über",
    investmentOutlook: "Investitionsausblick",
    lifestyle: "Lebensstil",
    worldClassAmenities: "Weltklasse-Annehmlichkeiten",
    unitTypes: "Einheitentypen",
    floorPlans: "Grundrisse",
    financing: "Finanzierung",
    typesSuffix: "Typen",
    sizeRange: "Größenbereich",
    units: "Einheiten",
    from: "Ab",
        ofTotalPayment: "der Gesamtzahlung",
        whyOffPlan: "Warum Off-Plan?",
        lowerEntryPrice: "Niedrigerer Einstiegspreis als bei fertigen Immobilien",
        spreadPayments: "Zahlungen über die Bauzeit verteilen",
        capitalAppreciation: "Wertsteigerung vor der Übergabe",
        zeroCommission: "0% Provision — Direktkauf",
        speakToAdvisor: "Mit einem Berater sprechen",
        openMap: "Genauen Standort in Google Maps öffnen",
        nearbyPlaces: "Orte in der Nähe",
        to: "nach",
        booking: "Buchung",
        installment: "Rate",
        handover: "Übergabe",
        areaUnit: "Flächeneinheit",
        currency: "Währung",
        youtubeLink: "YouTube-Videolink",
        watchVideo: "Video ansehen",
        watchTour: "Immobilienrundgang ansehen"
    },
  amenities: {
        "Kids Pool": "Kinderpool",
        "Private Beach Access": "Privater Strandzugang",
        "Marina Access": "Yachthafen-Zugang",
        "Outdoor Gym": "Außen-Fitnessstudio",
        "Basketball Court": "Basketballplatz",
        "Tennis Court": "Tennisplatz",
        "Padel Court": "Padel-Platz",
        "Cycling Track": "Radweg",
        "Spa & Wellness Center": "Spa & Wellness-Center",
        "Kids Play Area": "Kinderspielplatz",
        "Clubhouse": "Clubhaus",
        "Library": "Bibliothek",
        "Retail Outlets": "Einzelhandelsgeschäfte",
        "Cafes & Restaurants": "Cafés & Restaurants",
        "Supermarket": "Supermarkt",
        "Concierge Service": "Concierge-Service",
        "24/7 Security": "24/7 Sicherheit",
        "CCTV Surveillance": "Videoüberwachung",
        "Mosque": "Moschee",
        "Pet Friendly": "Haustierfreundlich",
        "Dining Destinations": "Gastronomieziele",
        "Yoga Studio": "Yoga-Studio",
        "Lush Green Parks": "Üppig grüne Parks",
        "Valet Parking": "Parkservice",
        "Smart Home Features": "Smart-Home-Funktionen",
        "Sauna & Steam Room": "Sauna & Dampfbad",
        "Covered Parking": "Überdachte Parkplätze",
        "Landscaped Gardens": "Landschaftsgärten",
    "Swimming Pool": "Schwimmbad",
    "State-of-the-art Gym": "Modernes Fitnessstudio",
    "BBQ Area": "Grillplatz",
    "Sports Courts": "Sportplätze",
    "Infinity Pool": "Infinity-Pool",
    "Running Track": "Laufbahn",
    "Cinema Room": "Kinoraum",
    "Games Room": "Spielzimmer"
}
}

export default de
